import React from "react";
import { withParam } from "./hooks/withParam";

const Wrapper = (props: any) => {
  return <>{props.children}</>;
};

export default withParam(Wrapper);
